/**
 * InputSize is used to define the size of the input field.
 * It controls the overall size of the input element, including padding and font size.
 * It is not the same as the HTML `size` attribute, which only controls the width
 * of the input element.
 * Replaces the `InputFieldSize` enum.
 */
export const InputSize = {
  Compact: 'compact',
  Default: 'default',
  Spacious: 'spacious',
} as const;
export type InputSize = (typeof InputSize)[keyof typeof InputSize];
